import MenuItemsList from 'components/pages/TruckMenuPage/MenuItems'
import { TruckMenuContentFragment } from 'components/TruckMenus/types/TruckMenuContentFragment'

const TruckMenu = ({
  items,
  upsellTypes,
  primaryUpsellTypes,
  showPrices,
  taxIncluded
}: {
  items: TruckMenuContentFragment['items']
  upsellTypes: {
    id: number
    name: string
  }[]
  primaryUpsellTypes: {
    id: number
    name: string
  }[]
  showPrices: boolean
  taxIncluded: boolean
}) => {
  return (
    <div className="flex flex-wrap mb-10">
      <MenuItemsList
        items={items}
        primaryUpsellTypes={primaryUpsellTypes}
        showPrices={showPrices}
        taxIncluded={taxIncluded}
        upsellTypes={upsellTypes}
      />
    </div>
  )
}

export default TruckMenu
